module.exports = __webpack_public_path__ + "img/sharif.2c04e288.png";